// For variant swatch functionality
function qAtcVariantOnchange(inp,desktop = true){
  console.log(desktop, "desktop");
  let wrapper = null;
  let container = null;
  let option1 = null;
  let option2 = null;
  let option3 = null;
  let m_inp = '';

  if (desktop) { // If desktop variant swatch
    wrapper = inp.closest('.q-atc-desk-variant-wrapper');
    container = wrapper.closest('.q-atc-desk-container');
  } else { // If mobile variant swatch
    wrapper = inp.closest('.q-atc-mob-variant-option-container');
    container = wrapper.closest('.q-atc-mob-content');
    m_inp = 'm-';
  }  
  let options_count = parseInt(wrapper.getAttribute('data-options-count'));
  // let product_id = parseInt(wrapper.getAttribute('data-product-id'));
  let product_id = wrapper.getAttribute('data-product-id');
  let cart_btn = container.querySelector('.q-atc-btn');
  let product_data = window.q_atc_products[product_id];
    // console.log(product_data, "product_data");
  // console.log(wrapper.querySelector(`input[name="option-${m_inp || ''}${product_id}-1"]:checked`), "ddddd")
  option1 = wrapper.querySelector(`input[name="option-${m_inp || ''}${product_id}-1"]:checked`)?.value || null;
  option2 = wrapper.querySelector(`input[name="option-${m_inp || ''}${product_id}-2"]:checked`)?.value || null;
  option3 = wrapper.querySelector(`input[name="option-${m_inp || ''}${product_id}-3"]:checked`)?.value || null;

  variant = false;

  // Matching variant with values
  for(let i = 0;i < product_data['variants'].length;i++){
    const v = product_data['variants'][i];
     
    if(v['option1'] === option1 && v['option2'] === option2 && v['option3'] === option3){
      variant = v;
      break;
    }
  }

  // Selected Variant
  if (variant) {
    // Set variant id
    cart_btn.setAttribute('data-selected-variant', variant.id);
  
    // Check availability
    if (variant.available === true) {
      cart_btn.textContent = 'Add To Cart';
      cart_btn.disabled = false;
    } else {
      cart_btn.textContent = 'Sold Out';
      cart_btn.disabled = true;
    }
  
    // Price change for mobile
    if (desktop === false) {
      let variant_price = paisaToInr(variant.price);
      let variant_compare_at_price = variant.compare_at_price ? paisaToInr(variant.compare_at_price) : '';
  
      let priceEl = container.querySelector('.q-atc-mob-price');
      if (priceEl) priceEl.textContent = variant_price;
  
      let comparePriceEl = container.querySelector('.q-atc-mob-compare-at-price s');
      if (comparePriceEl) comparePriceEl.textContent = variant_compare_at_price;
    }
  }  
}

// For add to cart the product (Desktop)
function qAtcProductAddToCart(btn){
  let variant_id = parseInt(btn.getAttribute('data-selected-variant'));
  let quantity = 1;
  let c = document.querySelector('cart-notification') || document.querySelector('cart-drawer-v2') || document.querySelector('cart-drawer');
  let sections = c.getSectionsToRender().map((section) => section.id)

  // Disable Btn
  btn.textContent = 'Adding . . .';
  btn.disabled = true;


  // Adding To Cart
  let formData = {
   'items': [{
    'id': variant_id,
    'quantity': quantity
    }],
    'sections' : sections
  };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(res => res.json())
  .then(cart => {
    // handleFloCartBtn();
    // Enable Btn
    btn.textContent = 'Add To Cart';
    btn.disabled = false;


    // Open cart drawer
    cart['items'][0]['sections'] = cart['sections'];
    c.renderContents(cart['items'][0]);
    if (c && c.classList.contains('is-empty')) c.classList.remove('is-empty');

    // For close the mobile quick add to cart popup
    if(window.matchMedia("(max-width: 1024px)").matches){
      qAtcMobCloseModel();
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
  
}

// For open the mobile quick add to cart model
function qAtcMobOpenModel(product_id = null){
  if(!product_id) return;
  let overlay = document.querySelector('.q-atc-mob-model-overlay');
  let model = document.querySelector('.q-atc-mob-model-wrapper');
  let product_data = window.q_atc_products[product_id];
  let product_options = window.q_atc_product_options[product_id];

  // Update Product Image
  let image_src = product_data['featured_image'] || null;
  let image = (image_src) ? `<img src="${image_src}&width=200" class="q-atc-mob-product-image"/>` : '';
  const quickWrapper = model.querySelector('.q-atc-mob-product-image-wrapper');
  if (quickWrapper) quickWrapper.innerHTML = image;

  //Product Image End

  // Update Product Info
  let info_html = `
    <h5 class="q-atc-mob-product-title">${product_data['title']}</h5>
    <div class="q-atc-mob-product-price-wrapper">
      <span class="q-atc-mob-compare-at-price"><s>${(product_data['compare_at_price']) ? paisaToInr(product_data['compare_at_price']) : ''}</s></span>
      <span class="q-atc-mob-price">${paisaToInr(product_data['price'])}</span>
    </div>
  `;
  const infoWrapper = model.querySelector('.q-atc-mob-product-i-wrapper');
  if (infoWrapper) infoWrapper.innerHTML = info_html;

  //Product Info End

  // Update Product Options
  let options_html = '';
  if(product_options != 'default'){
    let options_length = product_options.length;
    options_html += `
      <div 
        class="q-atc-mob-variant-option-container" 
        data-options-count="${options_length}"
        data-product-id="${product_id}"
      >
    `;
    
    // Options Loop
    for(let i = 0;i < product_options.length;i++){
      options_html += `
        <div
          class="q-atc-mob-variant-option" 
          data-option-name="${product_options[i]['name']}" 
          data-option-position="${product_options[i]['position']}"
        >
      `;
      
      // Option title
      options_html += `<h3 class="q-atc-mob-option-title">${product_options[i]['name']}</h3>`;

      // Option Values
      options_html += `<div class="q-atc-mob-option-values-wrapper">`;
      for(let j = 0;j < product_options[i]['values'].length;j++){
        let color_img = document.querySelector(`.q-atc-desk-label img[data-option-name="${product_options[i]['name']}"][data-product-id="${product_id}"][data-option-value="${product_options[i]['values'][j]}"]`);
        let c_image = false;
        if(color_img){
          c_image = `
            <img 
              src="${color_img.src}" 
              data-option-name="${product_options[i]['name']}"
              data-product-id="${product_id}"
              data-option-value="${product_options[i]['values'][j]}"
              alt="${product_options[i]['name']}"
              width="100"
              height="100"
            />
          `;
        }
        
        let id = `option-m-${product_id}-${product_options[i]['name'].toLowerCase().replace(' ','_')}-${product_options[i]['values'][j].toLowerCase().replace(' ','_')}`;
        options_html += `
         <input 
            style="display:none;"
            onchange="qAtcVariantOnchange(this,false)"
            type="radio" 
            class="q-atc-mob-input"
            data-option-position="${product_options[i]['position']}"
            value="${product_options[i]['values'][j]}"
            data-option-name="${product_options[i]['name']}" 
            id="${id}"
            name="option-m-${product_id}-${product_options[i]['position']}"
            ${(product_options[i]['name'] != 'Size' && product_options[i]['name'] != 'size' && j == 0) ? 'checked' : ''}
          />
          <label 
            class="q-atc-mob-label"
            for="${id}"
            data-option-name="${product_options[i]['name'].toLowerCase()}"
            data-option-image="${(color_img) ? true : false}"
            data-option-value
          >
            ${(color_img) ? c_image : product_options[i]['values'][j]}
          </label>
        `;
      }
      
      options_html += '</div>';
      
      
      options_html += '</div>';
    }
    options_html += '</div>';
  }
  const variantsWrapperQuick = model.querySelector('.q-atc-mob-product-variants-wrapper');
  if (variantsWrapperQuick) variantsWrapperQuick.innerHTML = options_html;

  // Product Options End

  // Update Add To Cart Button
  if(product_options == 'default'){//If default product
    
    
    if(product_data['variants'][0]['available'] === true){
      const atcBtnQuick = model.querySelector('.q-atc-btn');
      if (atcBtnQuick) {
        atcBtnQuick.disabled = false;
        atcBtnQuick.textContent = 'Add To Cart';
      }
    }else{
      const atcBtnQuick = model.querySelector('.q-atc-btn');
      if (atcBtnQuick) {
        atcBtnQuick.disabled = true;
        atcBtnQuick.textContent = 'Sold Out';
      }
    }
    const atcBtnQuick = model.querySelector('.q-atc-btn');
    if (atcBtnQuick) {
      atcBtnQuick.setAttribute('data-default-product', 'true');
      atcBtnQuick.setAttribute('data-selected-variant', product_data.variants[0].id);
    }

    
  }else{//Variant Product

    const atcBtnQuick = model.querySelector('.q-atc-btn');
    if (atcBtnQuick) {
      atcBtnQuick.disabled = true;
      atcBtnQuick.textContent = 'Add To Cart';
      atcBtnQuick.setAttribute('data-default-product', 'false');
      atcBtnQuick.setAttribute('data-selected-variant', '');
    }
  }
  // Add To Cart Button End

  
const option_selector_list = document.querySelectorAll('.q-atc-mob-variant-option');
const selectedVariant = product_data['variants'][0];
console.log(selectedVariant, "selectedVariant")
 const applyClassToSelector = (selector, valueIndex, available, hasAtLeastOneCombination) => {
    const optionValue = Array.from(selector.querySelectorAll("[data-option-value]"))[valueIndex];
    optionValue.toggleAttribute("hidden", !hasAtLeastOneCombination);
    if (null) {
      optionValue.toggleAttribute("hidden", !available);
    } else {
      optionValue.classList.toggle("is-disabled", !available);
    }
  };
  

  if (option_selector_list && option_selector_list[0]) {
    product_options[0]["values"].forEach((value, valueIndex) => {
      const hasAtLeastOneCombination = product_data["variants"].some((variant) => variant["option1"] === value && variant), hasAvailableVariant = product_data["variants"].some((variant) => variant["option1"] === value && variant["available"]);
      applyClassToSelector(option_selector_list[0], valueIndex, hasAvailableVariant, hasAtLeastOneCombination);
      if (option_selector_list[1]) {
        product_options[1]["values"].forEach((value2, valueIndex2) => {
          const hasAtLeastOneCombination2 = product_data["variants"].some((variant) => variant["option2"] === value2 && variant["option1"] === selectedVariant["option1"] && variant), hasAvailableVariant2 = product_data["variants"].some((variant) => variant["option2"] === value2 && variant["option1"] === selectedVariant["option1"] && variant["available"]);
          applyClassToSelector(option_selector_list[1], valueIndex2, hasAvailableVariant2, hasAtLeastOneCombination2);
          if (option_selector_list[2]) {
            product_options[2]["values"].forEach((value3, valueIndex3) => {
              const hasAtLeastOneCombination3 = product_data["variants"].some((variant) => variant["option3"] === value3 && variant["option1"] === selectedVariant["option1"] && variant["option2"] === selectedVariant["option2"] && variant), hasAvailableVariant3 = product_data["variants"].some((variant) => variant["option3"] === value3 && variant["option1"] === selectedVariant["option1"] && variant["option2"] === selectedVariant["option2"] && variant["available"]);
              applyClassToSelector(option_selector_list[2], valueIndex3, hasAvailableVariant3, hasAtLeastOneCombination3);
            });
          }
        });
      }
    });
  }


  // display the model
  overlay.classList.add('active');
  model.classList.add('active');
}

// For hide the model
function qAtcMobCloseModel(){
  let overlay = document.querySelector('.q-atc-mob-model-overlay');
  let model = document.querySelector('.q-atc-mob-model-wrapper');
  model.classList.add('close');
  model.classList.remove('active');
  setTimeout(() => {
    model.classList.remove('close');
    overlay.classList.remove('active');
  }, 400);
}

// For convert paisa to inr
function paisaToInr(paisa = 0){
    let inr = Math.round(paisa/100);
    inr += '';
    let x = inr.split('.');
    let x1 = x[0];
    let x2 = x.length > 1 ? '.' + x[1] : '';
    let rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return 'Rs.' + x1 + x2;
}


document.addEventListener('click', function(event) {
  const element = event.target.closest('.variant-selector-plus .plus-icon-area');
  if (!element) return; // Click was outside

  const deskWrapper = document.querySelector('.q-atc-desk-wrapper');
  const selectedProductId = element.getAttribute('q-atc-data-id');
  const targetEl = document.querySelector(`[data-product-id="${selectedProductId}"]`);

  if (deskWrapper && deskWrapper.classList.contains('active')) {
    deskWrapper.classList.remove('active');
    if (targetEl) targetEl.classList.add('active');
  } else {
    if (targetEl) targetEl.classList.add('active');
  }
});


document.addEventListener('click', function(event) { 
  const btn = event.target.closest('.q-atc-close-btn');
  if (!btn) return; // Clicked outside close button

  if (btn.parentElement) {
    btn.parentElement.classList.remove('active');
  }
});


